import { createFileRoute } from '@tanstack/react-router';

import ProductAnalyticsPage from '@/components/products/specific/analytics/Page';

export const Route = createFileRoute('/products/$id/analytics')({
	component: ProductAnalyticsPage,
});
